/**
** 安全信息分类
 */
<template>
  <div id="ClassInformation" class="jc-page">
    <div class="jc-panel jc-page-head">
      <div class="header-title">{{ headerTitle }}</div>
      <div class="header-operation">
        <el-form ref="form">
					<el-form-item>
        <el-input 
            v-model="checkup_category_name"
            placeholder="检查项目分类名称"></el-input>
          </el-form-item>
          <el-form-item>
        <el-input 
              v-model="checkup_category_no"
              placeholder="检查项目分类编号"></el-input>
          </el-form-item>
          <el-form-item>
        <el-cascader clearable
              :options="cascaderOptions"
              props.checkStrictly = true
              :props="defaultProps"
              v-model="checkup_category_parent_id"
              placeholder="请选择父级"
              :show-all-levels="false"></el-cascader>
          </el-form-item>
        
          <el-button @click="getTableListInit">查询</el-button>
          <el-button @click="delect">删除</el-button>
          <el-button @click="addLine">添加</el-button>
          </el-form>
      </div>
    </div>
    <div class="jc-table-container jc-scroll-panel">
      <el-table
            ref="multipleTable"
            :data="this.tableData"
            @filter-change="filterTagTable"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- <el-table-column
            type="index"
            label="序号"
            width="55"
          ></el-table-column> -->
          <el-table-column label="检查项目分类名称" min-width="200">
            <template slot-scope="scope">{{
              scope.row.checkup_category_name
            }}</template>
          </el-table-column>
          <el-table-column label="父级" min-width="200" show-overflow-tooltip>
            <!-- :column-key="checkup_category_parent_name" -->
            <template slot-scope="scope">{{
              scope.row.checkup_category_parent_name==="-"? "顶级":scope.row.checkup_category_parent_name
            }}</template>
          </el-table-column>
          <el-table-column label="项目" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_name_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="评估内容" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_content_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="标准分" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_basic_score_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="评分标准" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_score_point_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="评估方式" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_method_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="检查要点/支撑材料" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_inspection_point_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="标准化要求" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_standard_require_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="企业达标标准" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_standard_point_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="评审方法" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_review_method_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="评审标准-否却项" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_review_criteria_no_but_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="评审标准-扣分项" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_review_criteria_deduction_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="标准化评审规范号" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_standard_review_number_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="标准化评审内容" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_standard_review_content_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="检查内容/考核要求" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_inspection_content_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="检查依据" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_inspection_basis_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="检查方法" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_inspection_method_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="案例照片" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_case_image_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="完成时限" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_complete_time_limit_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="自评/评审描述" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_problem_description_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="整改时限" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_improve_time_limit_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="问题分类" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_project_type_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="检查结果" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_inspection_result_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="照片" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_image_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="文档" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_file_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="扣分/加分" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_deduct_point_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="整改建议" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_improve_suggest_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="实际得分" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_actual_score_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>
          <el-table-column label="是否重点问题" width="100">
            <template slot-scope="scope">{{
              parseInt(scope.row.checkup_item_evaluation_key_issues_switch)
                ? "必填"
                : "忽略"
            }}</template>
          </el-table-column>



          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                @click="handleEdit(scope.$index, scope.row)"
                type="text"
                size="small"
                >编辑</el-button
              >
              <span>|</span>
              <el-button
                type="text"
                size="small"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="text-align:right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="count"
          layout="total, prev, pager, next"
          :total="total"
          >
        </el-pagination>
    </div>
    <!-- 添加、编辑分类 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="dialog"
      @close="resetForm('addClassificationForm')"
    >
      <el-form
        ref="addClassificationForm"
        :rules="rules"
        :model="addClassificationForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="分类名称" prop="checkup_category_name">
              <el-input
                v-model="addClassificationForm.checkup_category_name"
                placeholder="请输入分类名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="父级" prop="checkup_category_parent_info">
              <el-cascader clearable
                :options="cascaderOptions"
                :props="defaultProps"
                style="width: 100%"
                v-model="addClassificationForm.checkup_category_parent_info.checkup_category_parent_id"
                placeholder="请选择父级"
                :show-all-levels="false"
                @change="handleParentChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="检查项目分类编号" prop="checkup_category_no">
              <el-input
                v-model="addClassificationForm.checkup_category_no"
                placeholder="请输入检查项目分类编号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <h3 style="float: left">检查项目设置</h3>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="项目"
              prop="checkup_item_name_switch"
            >
              <el-select :class="addClassificationForm.checkup_item_name_switch == 1 ? 'required-value':''"
                v-model="
                  addClassificationForm.checkup_item_name_switch
                "
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="评估内容"
              prop="checkup_item_evaluation_content_switch"
            >
              <el-select :class="addClassificationForm.checkup_item_evaluation_content_switch == 1 ? 'required-value':''"
                v-model="
                  addClassificationForm.checkup_item_evaluation_content_switch
                "
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="标准分" prop="checkup_item_basic_score_switch">
              <el-select :class="addClassificationForm.checkup_item_basic_score_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_basic_score_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评分标准" prop="checkup_item_score_point_switch">
              <el-select :class="addClassificationForm.checkup_item_score_point_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_score_point_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="评估方式"
              prop="checkup_item_evaluation_method_switch"
            >
              <el-select :class="addClassificationForm.checkup_item_evaluation_method_switch == 1 ? 'required-value':''"
                v-model="
                  addClassificationForm.checkup_item_evaluation_method_switch
                "
                placeholder="请选择"
                @change="checkup_item_evaluation_method_switchChange"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="检查要点/支撑材料"
              prop="checkup_item_inspection_point_switch"
            >
              <el-select :class="addClassificationForm.checkup_item_inspection_point_switch == 1 ? 'required-value':''"
                v-model="
                  addClassificationForm.checkup_item_inspection_point_switch
                "
                placeholder="请选择"
                :disabled="
                  parseInt(addClassificationForm.checkup_item_evaluation_method_switch)
                    ? true
                    : false
                "
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="标准化要求" prop="checkup_item_standard_require_switch">
              <el-select :class="addClassificationForm.checkup_item_standard_require_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_standard_require_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业达标标准" prop="checkup_item_standard_point_switch">
              <el-select :class="addClassificationForm.checkup_item_standard_point_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_standard_point_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="评审方法" prop="checkup_item_review_method_switch">
              <el-select :class="addClassificationForm.checkup_item_review_method_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_review_method_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评审标准-否却项" prop="checkup_item_review_criteria_no_but_switch">
              <el-select :class="addClassificationForm.checkup_item_review_criteria_no_but_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_review_criteria_no_but_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="评审标准-扣分项" prop="checkup_item_review_criteria_deduction_switch">
              <el-select :class="addClassificationForm.checkup_item_review_criteria_deduction_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_review_criteria_deduction_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标准化评审内容" prop="checkup_item_standard_review_content_switch">
              <el-select :class="addClassificationForm.checkup_item_standard_review_content_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_standard_review_content_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="检查内容" prop="checkup_item_inspection_content_switch">
              <el-select :class="addClassificationForm.checkup_item_inspection_content_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_inspection_content_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="检查依据" prop="checkup_item_inspection_basis_switch">
              <el-select :class="addClassificationForm.checkup_item_inspection_basis_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_inspection_basis_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="检查方法" prop="checkup_item_inspection_method_switch">
              <el-select :class="addClassificationForm.checkup_item_inspection_method_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_inspection_method_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="案例照片" prop="checkup_item_case_image_switch">
              <el-select :class="addClassificationForm.checkup_item_case_image_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_case_image_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="完成时限" prop="checkup_item_complete_time_limit_switch">
              <el-select :class="addClassificationForm.checkup_item_complete_time_limit_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_complete_time_limit_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="标准化评审规范号" prop="checkup_item_standard_review_number_switch">
              <el-select :class="addClassificationForm.checkup_item_standard_review_number_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_standard_review_number_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <h3 style="float: left">评估设置</h3>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="自评/评审描述" prop="checkup_item_evaluation_problem_description_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_problem_description_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_problem_description_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="整改时限" prop="checkup_item_evaluation_improve_time_limit_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_improve_time_limit_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_improve_time_limit_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="问题分类" prop="checkup_item_evaluation_project_type_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_project_type_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_project_type_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="检查结果" prop="checkup_item_evaluation_inspection_result_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_inspection_result_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_inspection_result_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="照片" prop="checkup_item_evaluation_image_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_image_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_image_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文档" prop="checkup_item_evaluation_file_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_file_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_file_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="扣分/加分" prop="checkup_item_evaluation_deduct_point_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_deduct_point_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_deduct_point_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="整改建议" prop="checkup_item_evaluation_improve_suggest_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_improve_suggest_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_improve_suggest_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="实际得分" prop="checkup_item_evaluation_actual_score_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_actual_score_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_actual_score_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否重点问题" prop="checkup_item_evaluation_key_issues_switch">
              <el-select :class="addClassificationForm.checkup_item_evaluation_key_issues_switch == 1 ? 'required-value':''"
                v-model="addClassificationForm.checkup_item_evaluation_key_issues_switch"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in classificationOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
  
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('addClassificationForm')">取消</el-button>
        <el-button type="primary" @click="submitForm('addClassificationForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import quickLogin from "../../.././../network/test";
import {getCheckupCategoryDetail, getCheckupCategoryList, getCheckupCategoryTreeList, deleteCheckupCategoryInfo, saveCheckupCategoryInfo} from '@/apis/classInformation'
export default {
  name: "ClassInformation",
  data() {
    return {
      currentPage:1,// 当前页数
      count:10,//表格页数
      total:0,
      headerTitle: "安全信息分类",
      // headerTitle: this.$store.state.userId,
      dialogTitle: "添加分类",
      checkup_category_name: "",
      checkup_category_no: "",
      checkup_category_parent_id: "",
      multipleSelection: [], //表格
      dialogVisible: false, //对话框显示标识
      classificationOptions: [
        {
          value: '1',
          label: "必填",
        },
        {
          value: '0',
          label: "忽略",
        },
      ], // 父级机构
      tableData: [
       
      ], //表格内容
      rules: {
        //表格验证
        checkup_category_name: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_category_parent_name: [
          { required: false, message: "请输入", trigger: "blur" },
        ],
        checkup_category_no: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_name_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_content_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_basic_score_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_score_point_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_method_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_inspection_point_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_standard_require_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_standard_point_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_review_method_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_review_criteria_no_but_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_review_criteria_deduction_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_standard_review_number_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_standard_review_content_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_inspection_content_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_inspection_basis_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_inspection_method_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_case_image_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_complete_time_limit_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_problem_description_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_improve_time_limit_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_project_type_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_inspection_result_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_image_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_file_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_deduct_point_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_improve_suggest_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_actual_score_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        checkup_item_evaluation_key_issues_switch: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
      },
      addClassificationForm: {
        checkup_category_id: 0, //检查分类id
        checkup_category_name: "", //检查分类名称
        checkup_category_no: "", //检查分类编号
        checkup_category_parent_id: "", //检查分类父级id
        checkup_item_name_switch: "0", //评估内容(0-忽略;1-必填)
        checkup_item_evaluation_content_switch: "0", //标准分(0-忽略;1-必填)
        checkup_item_basic_score_switch: "0", //评分标准(0-忽略;1-必填)
        checkup_item_score_point_switch: "0", //评估方式(0-忽略;1-必填)
        checkup_item_evaluation_method_switch: "0", //支撑材料(0-忽略;1-必填)
        checkup_item_inspection_point_switch: "0", //评估内容(0-忽略;1-必填)
        checkup_item_standard_require_switch: "0", //标准分(0-忽略;1-必填)
        checkup_item_standard_point_switch: "0", //评分标准(0-忽略;1-必填)
        checkup_item_review_method_switch: "0", //评估方式(0-忽略;1-必填)
        checkup_item_review_criteria_no_but_switch: "0", //支撑材料(0-忽略;1-必填)
        checkup_item_review_criteria_deduction_switch: "0", //评估内容(0-忽略;1-必填)
        checkup_item_standard_review_number_switch: "0", //标准分(0-忽略;1-必填)
        checkup_item_standard_review_content_switch: "0", //标准分(0-忽略;1-必填)
        checkup_item_inspection_content_switch: "0", //评分标准(0-忽略;1-必填)
        checkup_item_inspection_basis_switch: "0", //评估方式(0-忽略;1-必填)
        checkup_item_inspection_method_switch: "0", //支撑材料(0-忽略;1-必填)
        checkup_item_case_image_switch: "0", //评估内容(0-忽略;1-必填)
        checkup_item_complete_time_limit_switch: "0", //标准分(0-忽略;1-必填)
        checkup_item_evaluation_problem_description_switch: "0", //评分标准(0-忽略;1-必填)
        checkup_item_evaluation_improve_time_limit_switch: "0", //评估方式(0-忽略;1-必填)
        checkup_item_evaluation_project_type_switch: "0", //支撑材料(0-忽略;1-必填)
        checkup_item_evaluation_inspection_result_switch: "0", //评估内容(0-忽略;1-必填)
        checkup_item_evaluation_image_switch: "0", //标准分(0-忽略;1-必填)
        checkup_item_evaluation_file_switch: "0", //评分标准(0-忽略;1-必填)
        checkup_item_evaluation_deduct_point_switch: "0", //评估方式(0-忽略;1-必填)
        checkup_item_evaluation_improve_suggest_switch: "0", //支撑材料(0-忽略;1-必填)
        checkup_item_evaluation_actual_score_switch: "0", //评估内容(0-忽略;1-必填)
        checkup_item_evaluation_key_issues_switch: "0", //标准分(0-忽略;1-必填)
        checkup_category_parent_name:"",
        checkup_category_parent_info:{
          checkup_category_parent_id:''
        }
      }, //添加分类的表单内容
      cascaderOptions: [],
      multipleSelection: [],
      defaultProps: {
        label: "checkup_category_name",
        value: "checkup_category_id",
        checkStrictly : true
      },
    };
  },
  mounted() {
    this.getTableListInit();
    this.loadClassTreeData()
  },
  methods: {
    handleParentChange(value){
      if(value.length > 0){
        let id = value[value.length-1]
        getCheckupCategoryDetail({checkup_category_id:id}).then(res=>{
          this.addClassificationForm.checkup_item_name_switch = res.data.data.checkup_category_info.checkup_item_name_switch
        this.addClassificationForm.checkup_item_evaluation_content_switch = res.data.data.checkup_category_info.checkup_item_evaluation_content_switch
        this.addClassificationForm.checkup_item_basic_score_switch = res.data.data.checkup_category_info.checkup_item_basic_score_switch
        this.addClassificationForm.checkup_item_score_point_switch = res.data.data.checkup_category_info.checkup_item_score_point_switch
        this.addClassificationForm.checkup_item_evaluation_method_switch = res.data.data.checkup_category_info.checkup_item_evaluation_method_switch
        this.addClassificationForm.checkup_item_inspection_point_switch = res.data.data.checkup_category_info.checkup_item_inspection_point_switch
        this.addClassificationForm.checkup_item_standard_require_switch = res.data.data.checkup_category_info.checkup_item_standard_require_switch
        this.addClassificationForm.checkup_item_standard_point_switch = res.data.data.checkup_category_info.checkup_item_standard_point_switch
        this.addClassificationForm.checkup_item_review_method_switch = res.data.data.checkup_category_info.checkup_item_review_method_switch
        this.addClassificationForm.checkup_item_review_criteria_no_but_switch = res.data.data.checkup_category_info.checkup_item_review_criteria_no_but_switch
        this.addClassificationForm.checkup_item_review_criteria_deduction_switch = res.data.data.checkup_category_info.checkup_item_review_criteria_deduction_switch
        this.addClassificationForm.checkup_item_standard_review_number_switch = res.data.data.checkup_category_info.checkup_item_standard_review_number_switch
        this.addClassificationForm.checkup_item_standard_review_content_switch = res.data.data.checkup_category_info.checkup_item_standard_review_content_switch
        this.addClassificationForm.checkup_item_inspection_content_switch = res.data.data.checkup_category_info.checkup_item_inspection_content_switch
        this.addClassificationForm.checkup_item_inspection_basis_switch = res.data.data.checkup_category_info.checkup_item_inspection_basis_switch
        this.addClassificationForm.checkup_item_inspection_method_switch = res.data.data.checkup_category_info.checkup_item_inspection_method_switch
        this.addClassificationForm.checkup_item_case_image_switch = res.data.data.checkup_category_info.checkup_item_case_image_switch
        this.addClassificationForm.checkup_item_complete_time_limit_switch = res.data.data.checkup_category_info.checkup_item_complete_time_limit_switch
        this.addClassificationForm.checkup_item_evaluation_problem_description_switch = res.data.data.checkup_category_info.checkup_item_evaluation_problem_description_switch
        this.addClassificationForm.checkup_item_evaluation_improve_time_limit_switch = res.data.data.checkup_category_info.checkup_item_evaluation_improve_time_limit_switch
        this.addClassificationForm.checkup_item_evaluation_project_type_switch = res.data.data.checkup_category_info.checkup_item_evaluation_project_type_switch
        this.addClassificationForm.checkup_item_evaluation_inspection_result_switch = res.data.data.checkup_category_info.checkup_item_evaluation_inspection_result_switch
        this.addClassificationForm.checkup_item_evaluation_image_switch = res.data.data.checkup_category_info.checkup_item_evaluation_image_switch
        this.addClassificationForm.checkup_item_evaluation_file_switch = res.data.data.checkup_category_info.checkup_item_evaluation_file_switch
        this.addClassificationForm.checkup_item_evaluation_deduct_point_switch = res.data.data.checkup_category_info.checkup_item_evaluation_deduct_point_switch
        this.addClassificationForm.checkup_item_evaluation_improve_suggest_switch = res.data.data.checkup_category_info.checkup_item_evaluation_improve_suggest_switch
        this.addClassificationForm.checkup_item_evaluation_actual_score_switch = res.data.data.checkup_category_info.checkup_item_evaluation_actual_score_switch
        this.addClassificationForm.checkup_item_evaluation_key_issues_switch = res.data.data.checkup_category_info.checkup_item_evaluation_key_issues_switch
        })
      }
    },
    loadClassTreeData(){
      getCheckupCategoryTreeList().then((res) => {
          if (res.data.status === "1") {
            this.$message.success(res.data.msg);
            this.cascaderOptions = res.data.data.checkup_category_tree_list;
            console.log(this.cascaderOptions)
          } else {
            this.$message.error(res.data.msg);
          }
        })
      .catch((error) => {});
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getTableListInit();
    },
    //获取表格与分类
    getTableListInit() {
      getCheckupCategoryList({
          checkup_category_name: this.checkup_category_name,
          checkup_category_no: this.checkup_category_no,
          checkup_category_parent_id:
            this.checkup_category_parent_id[
              this.checkup_category_parent_id.length - 1
            ],
          pagination: {
            page: this.currentPage,
            count: this.count,
          },
        }).then((res) => {
          console.log(res);
          this.tableData = res.data.data.checkup_category_list;
          this.count = res.data.data.paginated.count
          this.total = parseInt(res.data.data.paginated.total)
        })
        .catch((error) => {});
      //请求分类列表
      
    },
    //判断支撑材料必填
    checkup_item_evaluation_method_switchChange(value) {
      if (value) {
        this.addClassificationForm.checkup_item_inspection_point_switch = '1';
      }
    },

    // 获取选中的数据
    handleSelectionChange(val) {
      console.log("下面打印的是选中的数据");
      console.log(val);
      this.multipleSelection = val;
    },

    filterTagTable(filters) {
      console.log(filters);
      if (filters.aStatus) {
        this.filtersObj.etStatus = filters.aStatus[0];
      }
      if (filters.bStatus) {
        this.filtersObj.auStatus = filters.bStatus[0];
      }
    },

    addLine() {
      this.dialogVisible = true;
      this.dialogTitle = "添加分类";
    },
    //多选删除
    delect() {
      this.$confirm('是否确定删除数据？', "提示").then(()=>{
        let delArr = [];
      this.multipleSelection.forEach((item) => {
        delArr.push(item.checkup_category_id);
      });
      deleteCheckupCategoryInfo({
          checkup_category_id_list: delArr,
        })
        .then((res) => {
          console.log(res);
          if (res.data.status === "1") {
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
          this.getTableListInit(); //刪除後請求列表
        })
        .catch((error) => {});
      })
      
    },

    // 表格中点击"删除"
    handleDelete(index, row) {
      this.$confirm('是否确定删除数据？', "提示").then(()=>{
        deleteCheckupCategoryInfo({
          checkup_category_id_list: [row.checkup_category_id],
        })
        .then((res) => {
          console.log(res);
          if (res.data.status === "1") {
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
          this.getTableListInit(); //刪除後請求列表
        })
        .catch((error) => {});
      })
      
    },

    // 点击表格中"编辑"
    handleEdit(index, row) {
      getCheckupCategoryDetail({checkup_category_id:row.checkup_category_id}).then(res=>{
        console.log(res)
        this.dialogTitle = "编辑分类内容";
        this.dialogVisible = true;
        this.addClassificationForm = { ...res.data.data.checkup_category_info };
        console.log(this.cascaderOptions)
        this.addClassificationForm.checkup_category_parent_info.checkup_category_parent_id = 
          this.getParentIds(this.addClassificationForm.checkup_category_parent_info.checkup_category_parent_id)
        console.log(this.addClassificationForm)
      })
    },
    getParentIds(parentId){
      let ids = []
      for(let i=0; i<this.cascaderOptions.length; i++){
        if(this._getParentIds(this.cascaderOptions[i], parentId, ids)){
          ids.unshift(this.cascaderOptions[i].checkup_category_id)
          break
        }
      }
      return ids
    },
    _getParentIds(data, parentId, ids){
      if(data.checkup_category_id == parentId){
        return true
      } else {
        for(let i=0; data.children && i<data.children.length; i++){
          if(this._getParentIds(data.children[i], parentId, ids)){
            ids.unshift(data.children[i].checkup_category_id)
            return true
          }
        }
      }
      return false
    },
    resetForm(formName) {
      //重置表单
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
      this.addClassificationForm = {
        checkup_category_id: 0,
        checkup_category_name: "",
        checkup_category_no: "",
        checkup_category_parent_id: "",
        checkup_item_name_switch: "", //评估内容(0-忽略;1-必填)
        checkup_item_evaluation_content_switch: "", //标准分(0-忽略;1-必填)
        checkup_item_basic_score_switch: "", //评分标准(0-忽略;1-必填)
        checkup_item_score_point_switch: "", //评估方式(0-忽略;1-必填)
        checkup_item_evaluation_method_switch: "", //支撑材料(0-忽略;1-必填)
        checkup_item_inspection_point_switch: "", //评估内容(0-忽略;1-必填)
        checkup_item_standard_require_switch: "", //标准分(0-忽略;1-必填)
        checkup_item_standard_point_switch: "", //评分标准(0-忽略;1-必填)
        checkup_item_review_method_switch: "", //评估方式(0-忽略;1-必填)
        checkup_item_review_criteria_no_but_switch: "", //支撑材料(0-忽略;1-必填)
        checkup_item_review_criteria_deduction_switch: "", //评估内容(0-忽略;1-必填)
        checkup_item_standard_review_number_switch: "",
        checkup_item_standard_review_content_switch: "", //标准分(0-忽略;1-必填)
        checkup_item_inspection_content_switch: "", //评分标准(0-忽略;1-必填)
        checkup_item_inspection_basis_switch: "", //评估方式(0-忽略;1-必填)
        checkup_item_inspection_method_switch: "", //支撑材料(0-忽略;1-必填)
        checkup_item_case_image_switch: "", //评估内容(0-忽略;1-必填)
        checkup_item_complete_time_limit_switch: "", //标准分(0-忽略;1-必填)
        checkup_item_evaluation_problem_description_switch: "", //评分标准(0-忽略;1-必填)
        checkup_item_evaluation_improve_time_limit_switch: "", //评估方式(0-忽略;1-必填)
        checkup_item_evaluation_project_type_switch: "", //支撑材料(0-忽略;1-必填)
        checkup_item_evaluation_inspection_result_switch: "", //评估内容(0-忽略;1-必填)
        checkup_item_evaluation_image_switch: "", //标准分(0-忽略;1-必填)
        checkup_item_evaluation_file_switch: "", //评分标准(0-忽略;1-必填)
        checkup_item_evaluation_deduct_point_switch: "", //评估方式(0-忽略;1-必填)
        checkup_item_evaluation_improve_suggest_switch: "", //支撑材料(0-忽略;1-必填)
        checkup_item_evaluation_actual_score_switch: "", //评估内容(0-忽略;1-必填)
        checkup_item_evaluation_key_issues_switch: "", //标准分(0-忽略;1-必填)
        checkup_category_parent_info:{
          checkup_category_parent_id:''
        }
      };
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.addClassificationForm)
          console.log(this.addClassificationForm.checkup_category_parent_name)
          if(this.addClassificationForm.checkup_category_parent_info &&
            this.addClassificationForm.checkup_category_parent_info.checkup_category_parent_id &&
            this.addClassificationForm.checkup_category_parent_info.checkup_category_parent_id.length > 0){
             this.addClassificationForm.checkup_category_parent_id=this.addClassificationForm.checkup_category_parent_info.checkup_category_parent_id[this.addClassificationForm.checkup_category_parent_info.checkup_category_parent_id.length - 1]
          } else {
            this.addClassificationForm.checkup_category_parent_id=""
          }
          saveCheckupCategoryInfo({
            "checkup_category_id" : this.addClassificationForm.checkup_category_id,
            "checkup_category_name" : this.addClassificationForm.checkup_category_name,
            "checkup_category_no" : this.addClassificationForm.checkup_category_no,
            "checkup_category_parent_id" : this.addClassificationForm.checkup_category_parent_id,
            "checkup_item_name_switch" : this.addClassificationForm.checkup_item_name_switch,
            "checkup_item_evaluation_content_switch" : this.addClassificationForm.checkup_item_evaluation_content_switch,
            "checkup_item_basic_score_switch" : this.addClassificationForm.checkup_item_basic_score_switch,
            "checkup_item_score_point_switch" : this.addClassificationForm.checkup_item_score_point_switch,
            "checkup_item_evaluation_method_switch" : this.addClassificationForm.checkup_item_evaluation_method_switch,
            "checkup_item_inspection_point_switch" : this.addClassificationForm.checkup_item_inspection_point_switch,
            "checkup_item_standard_require_switch" : this.addClassificationForm.checkup_item_standard_require_switch,
            "checkup_item_standard_point_switch" : this.addClassificationForm.checkup_item_standard_point_switch,
            "checkup_item_review_method_switch" : this.addClassificationForm.checkup_item_review_method_switch,
            "checkup_item_review_criteria_no_but_switch" : this.addClassificationForm.checkup_item_review_criteria_no_but_switch,
            "checkup_item_review_criteria_deduction_switch" : this.addClassificationForm.checkup_item_review_criteria_deduction_switch,
            "checkup_item_standard_review_number_switch" : this.addClassificationForm.checkup_item_standard_review_number_switch,
            "checkup_item_standard_review_content_switch" : this.addClassificationForm.checkup_item_standard_review_content_switch,
            "checkup_item_inspection_content_switch" : this.addClassificationForm.checkup_item_inspection_content_switch,
            "checkup_item_inspection_basis_switch" : this.addClassificationForm.checkup_item_inspection_basis_switch,
            "checkup_item_inspection_method_switch" : this.addClassificationForm.checkup_item_inspection_method_switch,
            "checkup_item_case_image_switch" : this.addClassificationForm.checkup_item_case_image_switch,
            "checkup_item_complete_time_limit_switch" : this.addClassificationForm.checkup_item_complete_time_limit_switch,
            "checkup_item_evaluation_problem_description_switch" : this.addClassificationForm.checkup_item_evaluation_problem_description_switch,
            "checkup_item_evaluation_improve_time_limit_switch" : this.addClassificationForm.checkup_item_evaluation_improve_time_limit_switch,
            "checkup_item_evaluation_project_type_switch" : this.addClassificationForm.checkup_item_evaluation_project_type_switch,
            "checkup_item_evaluation_inspection_result_switch" : this.addClassificationForm.checkup_item_evaluation_inspection_result_switch,
            "checkup_item_evaluation_image_switch" : this.addClassificationForm.checkup_item_evaluation_image_switch,
            "checkup_item_evaluation_file_switch" : this.addClassificationForm.checkup_item_evaluation_file_switch,
            "checkup_item_evaluation_deduct_point_switch" : this.addClassificationForm.checkup_item_evaluation_deduct_point_switch,
            "checkup_item_evaluation_improve_suggest_switch" : this.addClassificationForm.checkup_item_evaluation_improve_suggest_switch,
            "checkup_item_evaluation_actual_score_switch" : this.addClassificationForm.checkup_item_evaluation_actual_score_switch,
            "checkup_item_evaluation_key_issues_switch" : this.addClassificationForm.checkup_item_evaluation_key_issues_switch
          })
            .then((res) => {
              console.log(res);
              if (res.data.status === "1") {
                this.$message.success(res.data.msg);
              } else {
                this.$message.error(res.data.msg);
              }
              this.getTableListInit(); //添加後請求列表
              this.loadClassTreeData()
              this.dialogVisible = false;
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.dialogVisible = false;
              this.$refs[formName].resetFields();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
#ClassInformation {
  position: relative;
}
.header {
  width: 100%;
  height: 35px !important;
  border-bottom: 1px solid #ccc;
}
.header-left {
  width: 200px;
  text-align: left;
  position: absolute;
}

.header-right {
  position: absolute;
  right: 20px;
  /* width: 55%; */
  height: 35px;
}
.el-form {
  display: flex;
  height: 35px;
}
.el-form-item {
  width: 180px;
  margin-right: 10px;
}
.button {
  height: 38px;
  color: #fff;
  background-color: #000;
}
#ClassInformation >>> .el-input__inner {
  height: 35px;
  padding: 0 10px;
  border: 1px solid #000;
}
#ClassInformation >>> .el-input input::-webkit-input-placeholder {
  color: #9e9fa3;
}
/* 表格样式修改 */
.el-table {
  color: #000;
}
#ClassInformation >>> .el-table thead {
  color: #000;
  font-weight: unset;
}
#ClassInformation >>> .el-table__header {
  width: 100%;
}
#ClassInformation >>> .el-table th.el-table__cell {
  background-color: #f3f3f3;
}
/* #ClassInformation >>> .el-table tr{
    
} */
#ClassInformation >>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: unset;
}
.el-button--text {
  color: #000;
  font-size: 13px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
#ClassInformation >>> .el-checkbox__inner {
  width: 16px;
  height: 16px;
  border: 1px solid #9e9fa3;
}
/* 对话框样式修改 */
#ClassInformation >>> .dialog .el-dialog__header {
  text-align: left;
}
#ClassInformation >>> .dialog .el-dialog__title {
  font-size: 20px;
}
#ClassInformation >>> .dialog .el-dialog__body {
  padding: 10px 20px;
  color: #000;
}
#ClassInformation >>> .dialog .el-dialog__body .el-form {
  width: 100%;
  height: 100%;
  display: block;
}
#ClassInformation >>> .dialog .el-dialog__body .el-form-item {
  width: 85%;
  margin-bottom: 15px;
}
#ClassInformation >>> .dialog .el-form-item__label {
  color: #000;
  font-size: 16px;
  text-align: left;
  line-height: 35px;
}
#ClassInformation >>> .dialog .el-input__inner {
  border: 1px solid #409eff;
  color: #000;
}
#ClassInformation >>> .dialog .el-select {
  width: 100%;
}
#ClassInformation >>> .dialog .el-dialog__footer {
  padding: 0px 20px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/backStage/children/ClassInformation/ClassInformation.vue